<mat-dialog-content>
    <app-sso-buttons [providers]="data.providers" [community]="data.community"/>
</mat-dialog-content>
